'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, s = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (s[r] = e[r]);
    }
    return s;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, s = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (s[r] = e[r]);
    return s;
}
const Visible = renderWithRef('Visible', null, (r, i)=>{
    useComponentStylesLoaded('Visible', SWAN_STYLE_KEY_MAP.visible);
    let { xs: n = false, sm: l = false, md: a = false, lg: p = false, xl: c = false, children: d } = r, b = _object_without_properties(r, [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "children"
    ]), m = new Set();
    return n && m.add('swan-visible-xs'), l && m.add('swan-visible-sm'), a && m.add('swan-visible-md'), p && m.add('swan-visible-lg'), c && m.add('swan-visible-xl'), jsx(RenderComp, {
        root: "div",
        forwardedRef: i,
        classNames: m,
        props: b,
        children: d
    });
});

export { Visible };
